import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const IGNORE_ROUTES = ["/auth/verify-email", "/oauth-callback"];

export const AuthLayout = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (isAuthenticated && !IGNORE_ROUTES.includes(window.location.pathname)) {
    // Check if user is trying to access auth pages with plan=pro parameter
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('plan') === 'pro') {
      return <Navigate to="/settings/subscription?plan=pro" replace />;
    }
    
    // User is authenticated, redirect to the main page
    return <Navigate to="/" replace />;
  }

  return (
    <main className="main-auth">
      <Outlet />
    </main>
  );
};
